// @flow
import client from '../../client'

// API Endpoints
export const GET_WITHDRAWALS_ENDPOINT = '/travel_agent/withdrawals/'

/**
 * Returns withdrawals
 * @return {Promise|Error} A resolved Promise with withdrawals or Rejected with an Error
 */
export const getWithdrawals = (): Promise<any> =>
  client.get(GET_WITHDRAWALS_ENDPOINT)

export default getWithdrawals
